/**
 * WD-10 — Moderation action (dismiss / hide / unhide / delete).
 * US-A07 AC3: three of the queue's five actions; warn and ban reuse the
 * existing `WarnUserDialog` / `BanUserDialog`.
 */
import { useAdminTranslate } from '@/providers/i18n-provider'
import { ConfirmDialog } from './ConfirmDialog'

export type ModerationAction = 'dismiss' | 'hide' | 'unhide' | 'delete'

export interface ModerationActionDialogProps {
  open: boolean
  action: ModerationAction
  onConfirm: (reason: string) => Promise<void> | void
  onCancel: () => void
}

export const ModerationActionDialog = ({
  open,
  action,
  onConfirm,
  onCancel,
}: ModerationActionDialogProps) => {
  const translate = useAdminTranslate()

  return (
    <ConfirmDialog
      open={open}
      danger={action === 'delete' || action === 'hide'}
      title={translate(`admin.dialogs.moderationAction.${action}Title`)}
      description={translate(`admin.dialogs.moderationAction.${action}Description`)}
      confirmLabel={translate(`admin.dialogs.moderationAction.${action}Confirm`)}
      requireReason
      reasonLabel={translate('admin.dialogs.moderationAction.reasonLabel')}
      typeToConfirm={
        action === 'delete' ? translate('admin.dialogs.delete.typeToConfirm') : undefined
      }
      onConfirm={reason => onConfirm(reason ?? '')}
      onCancel={onCancel}
    />
  )
}
